import React from 'react';
import MobileStepper from './MobileStepper';
import WebStepper from './WebStepper';

const Stepper = props => {
  const {
    steps,
    stepperLabel,
    currentStep,
    stepperBarClass,
    stepperTextClass
  } = props;

  return (
    <>
      <WebStepper steps={steps} currentStep={currentStep} />
      <MobileStepper
        steps={steps}
        stepperLabel={stepperLabel}
        currentStep={currentStep}
        stepperBarClass={stepperBarClass}
        stepperTextClass={stepperTextClass}
      />
    </>
  );
};

export default Stepper;
